


const KakaoIcon = ({ size = 24, color = 'currentColor', ...props }) => {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 3C6.477 3 2 6.692 2 11.25C2 14.155 3.825 16.702 6.573 18.164C6.413 18.686 5.608 21.287 5.589 21.483C5.589 21.483 5.569 21.648 5.675 21.711C5.781 21.774 5.913 21.745 5.913 21.745C6.224 21.702 9.515 19.392 10.092 18.988C10.708 19.076 11.345 19.125 12 19.125C17.523 19.125 22 15.683 22 11.25C22 6.817 17.523 3 12 3Z"
            fill={color}
            />
        </svg>
    );
};

const KakaoLoginButton = () => {
    return (
        <div
            onClick={()=>{
                const CLIENT_ID = process.env.REACT_APP_KAKAO_CLIENT_ID;
                const REDIRECT_URI = process.env.REACT_APP_KAKAO_REDIRECT_URI;
                const RESPONSE_TYPE = "code"; // CSRF 방지를 위해 임의값

                const API_ENDPOINT = `https://kauth.kakao.com/oauth/authorize?client_id=${CLIENT_ID}&redirect_uri=${REDIRECT_URI}&response_type=${RESPONSE_TYPE}`

                window.location.href = API_ENDPOINT;

         
            }}
            style={{
                display: "flex",
                height: "56px",
                padding: "8px 0px",
                justifyContent: "center",
                alignItems: "center",
                gap: "8px",
                alignSelf: "stretch",
                background: '#FFDB01',
                borderRadius: '12px',
                cursor: 'pointer',
            }}
        >

            <KakaoIcon/>

            <span
                style={{
                    color: "#000000",
                    fontFamily: "Pretendard",
                    fontSize: "16px",
                    fontStyle: "normal",
                    fontWeight: 700,
                    lineHeight: "100%",
                    letterSpacing: "-0.6px",
                }}
            >
                카카오로 로그인하기
            </span>

        </div>
    )
}



export default KakaoLoginButton;